import React, { memo, useMemo, useState } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';
import PropTypes from 'prop-types';

import { getPickerTabsConfig, MODAL_TITLE, PickerTab } from './AddConditionsForm.constants';
import AddAdhocConditionContent from './components/AddAdhocConditionContent';
import AddConditionsContent from './components/AddConditionsContent';

const AddConditionsForm = ({
  isOpen,
  loanId,
  initialForm,
  customOnAssignFormClick,
  isAdhocAllowed = false,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState(PickerTab.CONDITIONS);

  const navigationTabs = useMemo(
    () =>
      getPickerTabsConfig({ isAdhocAllowed }).map(({ label, value }) => ({
        label,
        value,
        onClick: () => setActiveTab(value),
      })),
    [isAdhocAllowed],
  );

  const additionalProps = useMemo(
    () => ({
      activeTab,
      loanId,
      initialForm,
      customOnAssignFormClick,
    }),
    [activeTab, loanId, initialForm, customOnAssignFormClick],
  );

  const Content = activeTab === PickerTab.ADHOC ? AddAdhocConditionContent : AddConditionsContent;

  return (
    <EntityFormModal
      isData
      Content={Content}
      additionalProps={additionalProps}
      isOpen={isOpen}
      navigationTabs={navigationTabs}
      navigationValue={activeTab}
      title={MODAL_TITLE}
      onClose={onClose}
    />
  );
};

AddConditionsForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loanId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  initialForm: PropTypes.object,
  customOnAssignFormClick: PropTypes.func,
  isAdhocAllowed: PropTypes.bool,
};

export default memo(AddConditionsForm);
